import AxiosClient from "../Network/AxiosClient";

export const fetcher = async (url) => {
  const response = await AxiosClient.get(url, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
    },
  });
  return response.data;
};
